import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';

export const employeeFormDefaultValues: EmployeeFormFields = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  role: null,
  departmentId: '',
  locationId: '',
  internalId: '',
  subDepartment: '',
  corpDinerSettings: {
    allocationsPermitted: true,
    ssoUniqueIdentifier: '',
    sentWelcomeEmail: null,
  },
};
